if (!window.AroPuffBuyNowInitialized) {
  window.AroPuffBuyNowInitialized = true;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
    if (!variant?.id) return;

    document
      .querySelectorAll(`[data-aropuff-buy-now-form][data-section-id="${sectionId}"] input[name="id"]`)
      .forEach((input) => {
        input.value = variant.id;
      });
  });
}
